import {
    Component,
    Host,
    h,
    Element,
    forceUpdate,
    Prop,
    State,
    ComponentInterface,
    Listen,
} from "@stencil/core";
// TODO: Use CDN version of @trumpf/ux.application-framework when available
import { defineCustomElement as defineAuthImage } from "@trumpf/ux.application-framework/dist/components/uxc-auth-image";
import { ProductionStatus } from "../production-status/production-status-enum";
import { Status } from "../status-label/status";
import { Wrapper } from "./wrapper";
import { i18nProvider } from "@trumpf/ux.i18n";

// TODO: Use CDN version of @trumpf/ux.application-framework when available
defineAuthImage();

let increment = 0;

// TODO: refactor component, adjust naming -> ux-iws-machine-tile
@Component({
    tag: "ux-iws-tile",
    styleUrl: "tile.scss",
})
export class Tile implements ComponentInterface {
    private baseClass = "ux-iws-tile";
    private uid = `ux-iws-tile-${++increment}`;
    private i18nSubscriberId: string;

    @Element() domNode: HTMLUxIwsTileElement;

    /** name of the machine  */
    @Prop({ reflect: true }) machineName: string;

    /** custom name of the machine  */
    @Prop({ reflect: true }) customMachineName: string;

    /** id of the machine */
    @Prop({ reflect: true }) machineId: string;

    /** url for machine image */
    @Prop({ reflect: true }) machineImageUrl: string;

    /** indicates that ux-auth-image should be used */
    @Prop({ reflect: true }) authImage: boolean;

    /** shop link url */
    @Prop({ reflect: true }) shopLink: string;

    /** shop type */
    @Prop({ reflect: true }) shopLinkType: string;

    /** shop link title which is shown on hover or as button title */
    @Prop({ reflect: true }) shopLinkTitle: string;

    /** @deprecated support for NOT Stateful version -> shop icon which is shown as part of the button when overlay is active */
    @Prop({ reflect: true }) shopLinkIcon: string;

    /** shop link target */
    @Prop({ reflect: true }) shopLinkTarget: string = "";

    /** second shop link */
    @Prop({ reflect: true }) shopLink2: string;

    /** second shop type */
    @Prop({ reflect: true }) shopLink2Type: string;

    /** shop link title for second shop which is shown on hover or as button title */
    @Prop({ reflect: true }) shopLink2Title: string;

    /** @deprecated support for NOT Stateful version -> shop link title for second shop which is shown on hover or as button title */
    @Prop({ reflect: true }) shopLink2Icon: string;

    /** shop link target */
    @Prop({ reflect: true }) shopLink2Target: string = "";

    /** link to detail page of machine */
    @Prop({ reflect: true }) detailLink: string;

    /** text which is displayed on the overlay */
    @Prop({ reflect: true }) chooseShopTitle: string;

    /** Link to create a new service call via a modal */
    @Prop() serviceCallModalLink: string = "";

    /** config for create-case micro frontend */
    @Prop() createCaseMfaConfig: {
        env: string;
        locale: string;
    } | null = null;

    /** Defines if the option for the creation of a service case is active */
    @Prop({ reflect: true }) serviceCaseCreationDisabled: boolean;

    /** @deprecated support for NOT Stateful version -> Header text for the case creation disabled explaination tooltip */
    @Prop() serviceCaseCreateDisabledHeaderText: string | null;

    /** @deprecated support for NOT Stateful version -> Body text for the case creation disabled explaination tooltip */
    @Prop() serviceCaseCreateDisabledBodyText: string | null;

    /** id for syncing favorite status */
    @Prop({ reflect: true }) syncId: string;

    /** bool for wether a machine was favorized */
    @Prop({ reflect: true }) isFav: boolean;

    /** url to toggle the favorite status of a machine  */
    @Prop({ reflect: true }) toggleFavUrl: string;

    /** indicates that the production year is lower than the IB1 date */
    @Prop({ reflect: true }) inProduction: string | false = false;

    /** indicates if software updates are available */
    @Prop({ reflect: true }) softwareUpdates: string | false = false;

    @Prop({ reflect: true }) softwareUpdatesState: Status | false = false;

    /** @deprecated support for NOT Stateful version -> software updates label */
    @Prop({ reflect: true }) softwareUpdatesLabel: string | false = false;

    /** bool for machine order tracking tag */
    @Prop({ reflect: true }) orderTracking: boolean;

    /** translate function to get the translation for a key */
    @Prop() translateFn?: (key: string) => string;

    @State() shopLinksLength: number;
    @State() overlayVisibility: boolean = false;
    @State() shopLinksArray: string[] = [];
    /** this indicates if the create case MFA modal is opened */
    @State() createCaseOpened: boolean = false;

    @Listen("uxModalClose")
    handleModalClose(): void {
        this.createCaseOpened = false;
    }

    componentWillLoad(): void {
        [this.shopLink, this.shopLink2].forEach((link) => {
            if (link === undefined) return;
            this.shopLinksArray.push(link);
        });
        this.shopLinksLength = this.shopLinksArray.length;
    }

    connectedCallback() {
        this.i18nSubscriberId = i18nProvider.subscribe(() => forceUpdate(this));
    }

    disconnectedCallback() {
        i18nProvider.unsubscribe(this.i18nSubscriberId);
    }

    private getShopIcon = (shopLinkType) => {
        switch (shopLinkType) {
            case "spareparts":
                return "cart-cogs";
            case "bending":
                return "cart-bending-tools";
            case "punching":
                return "cart-punching-tools";
            default:
                return "";
        }
    };

    render() {
        const { t } = i18nProvider;
        const modalName = `${this.uid}-modal-${this.machineId}`;
        const tileBodyStyles = this.authImage
            ? {
                  position: `relative`,
              }
            : this.inProduction === false
              ? {
                    backgroundImage: `url(${this.machineImageUrl})`,
                    backgroundSize: `cover`,
                }
              : {
                    // give opacity to the background without affecting the children elements
                    background: `linear-gradient(rgba(255,255,255,.6), rgba(255,255,255,.6)), url(${this.machineImageUrl})`,
                    backgroundSize: `cover`,
                };

        const hasDetailLink = this.detailLink ? true : false;
        const shopIcon1 = this.getShopIcon(this.shopLinkType);
        const shopIcon2 = this.getShopIcon(this.shopLink2Type);
        const useCreateCaseMFA =
            !this.serviceCaseCreationDisabled && !!this.createCaseMfaConfig;
        const useCreateCaseAsyncModal =
            !this.serviceCaseCreationDisabled &&
            this.serviceCallModalLink &&
            !useCreateCaseMFA;

        return (
            <Host
                class={{
                    [this.baseClass]: true,
                    ["ux-col-12 ux-col-md-6 ux-col-xl-4"]: true,
                }}
            >
                <Wrapper linkWrapper={hasDetailLink}>
                    <div
                        class={`ux-tile ${this.orderTracking ? "order-tracking" : ""}`}
                    >
                        <div class="ux-tile-head">
                            {/* this link is only for the LinkWrapper */}
                            {hasDetailLink && <a href={this.detailLink}></a>}
                            {this.orderTracking && (
                                <div class="order-tracking-bar ux-text-tiny ux-text-tiny--bold ux-u-text-uppercase">
                                    {t("orderTracking.label")}
                                </div>
                            )}
                            <div
                                data-ux-iws-link-wrapper-ignore
                                class="ux-tile-head__icon"
                            >
                                <ux-iws-async-toggle-button
                                    data-ux-iws-link-wrapper-ignore
                                    sync-id={`ux-iws-${this.syncId}`}
                                    toggle-url={this.toggleFavUrl}
                                    key={this.toggleFavUrl}
                                    on={this.isFav}
                                    onClick={(e: Event) => e.stopPropagation()}
                                >
                                    <span
                                        slot="on"
                                        style={{ color: "#b3d11e" }}
                                    >
                                        <ux-icon
                                            name="bookmark"
                                            filled=""
                                            size-s="27"
                                        ></ux-icon>
                                    </span>
                                    <span slot="off">
                                        <ux-icon
                                            name="bookmark"
                                            size-s="27"
                                        ></ux-icon>
                                    </span>
                                </ux-iws-async-toggle-button>
                                <slot name="discontinuation-icon"></slot>
                            </div>
                            <div class="ux-tile-head__text">
                                <div class="ux-tile-head__title">
                                    {this.customMachineName
                                        ? this.customMachineName
                                        : this.machineName}
                                </div>
                                {this.customMachineName && (
                                    <div class="ux-tile-head__machine-name ">
                                        {`(${this.machineName})`}
                                    </div>
                                )}

                                <div class="ux-tile-head__subtitle">
                                    {this.machineId}
                                </div>
                                <div class="ux-tile-head__status">
                                    {this.inProduction && (
                                        <ux-iws-production-status
                                            type={
                                                ProductionStatus.IN_PRODUCTION
                                            }
                                        >
                                            {this.inProduction}
                                        </ux-iws-production-status>
                                    )}
                                    {this.softwareUpdates && (
                                        <ux-w-status
                                            type={this.softwareUpdates}
                                        >
                                            {this.translateFn &&
                                                this.translateFn(
                                                    `softwareUpdates.values.${this.softwareUpdates}`
                                                )}
                                        </ux-w-status>
                                    )}
                                    {this.softwareUpdatesState &&
                                        this.softwareUpdatesLabel && (
                                            <ux-iws-status-label
                                                type={this.softwareUpdatesState}
                                            >
                                                {this.softwareUpdatesLabel}
                                            </ux-iws-status-label>
                                        )}
                                </div>
                            </div>
                        </div>
                        <div class="ux-tile-body" style={tileBodyStyles}>
                            {this.authImage && (
                                <uxc-auth-image
                                    src={this.machineImageUrl}
                                    scope="mytrumpf"
                                >
                                    {/** do not set src on ux-image manually, it will not look optimal while loading */}
                                    <ux-image
                                        width={100}
                                        height={55}
                                        object-fit="contain"
                                        alt={this.machineName}
                                    ></ux-image>
                                </uxc-auth-image>
                            )}
                            <div class="ux-tile-body__button-group">
                                {/* Only instantiate remote/async modals once translations are available
                                     to avoid conflicting translation sources (progressive rendering) */}
                                {useCreateCaseAsyncModal &&
                                    this.translateFn && (
                                        <ux-iws-async-modal
                                            data-ux-iws-link-wrapper-ignore
                                            src={this.serviceCallModalLink}
                                            name={modalName}
                                        ></ux-iws-async-modal>
                                    )}
                                {useCreateCaseMFA && this.createCaseOpened && (
                                    <mf-create-service-case-modal
                                        open
                                        data-ux-iws-link-wrapper-ignore
                                        file-upload
                                        modal-name={modalName}
                                        env={this.createCaseMfaConfig.env}
                                        locale={this.createCaseMfaConfig.locale}
                                        prefillData={{
                                            productData: {
                                                assetId: this.machineId,
                                            },
                                        }}
                                    >
                                        <ux-f-sis-create-case-connector slot="connector"></ux-f-sis-create-case-connector>
                                    </mf-create-service-case-modal>
                                )}
                                {this.serviceCaseCreationDisabled && (
                                    <ux-tooltip
                                        tooltip-target="button[name='service-case-creation-disabled-btn']"
                                        align="top"
                                        data-ux-iws-link-wrapper-ignore
                                    >
                                        <div class="flex flex--col flex--align-center">
                                            <span
                                                style={{
                                                    color: `red`,
                                                }}
                                                class="ux-u-mb-xxxs"
                                            >
                                                <ux-icon
                                                    name="close"
                                                    size-l="32"
                                                    weight="normal"
                                                ></ux-icon>
                                            </span>
                                            <h6 class="ux-u-ml-xxxs ux-u-mt-xxxs ux-u-mb-zero ux-text-headline ux-text-headline--small ux-u-text-align--center">
                                                {(this.translateFn &&
                                                    this.translateFn(
                                                        "disabledCreateCase.headerText"
                                                    )) ||
                                                    this
                                                        .serviceCaseCreateDisabledHeaderText}
                                            </h6>
                                        </div>
                                        <p class="ux-text-normal">
                                            {(this.translateFn &&
                                                this.translateFn(
                                                    "disabledCreateCase.bodyText"
                                                )) ||
                                                this
                                                    .serviceCaseCreateDisabledBodyText}
                                        </p>
                                    </ux-tooltip>
                                )}
                                {(useCreateCaseAsyncModal ||
                                    useCreateCaseMFA ||
                                    this.serviceCaseCreationDisabled) && (
                                    <button
                                        data-ux-iws-link-wrapper-ignore
                                        name={
                                            this.serviceCaseCreationDisabled
                                                ? "service-case-creation-disabled-btn"
                                                : "service-case-creation-btn"
                                        }
                                        class="ux-button ux-button--icon-only ux-iws-link-wrapper-ignore"
                                        data-testid="create-service-case"
                                        disabled={
                                            this.serviceCaseCreationDisabled
                                        }
                                        onClick={() => {
                                            if (useCreateCaseMFA) {
                                                this.createCaseOpened = true;
                                            }
                                        }}
                                        data-trigger-async-modal={
                                            useCreateCaseAsyncModal
                                                ? `open,${modalName}`
                                                : undefined
                                        }
                                    >
                                        <ux-icon name="hand-plus-right" />
                                    </button>
                                )}
                                {this.shopLinksLength === 1 && (
                                    <a
                                        data-ux-iws-link-wrapper-ignore
                                        href={this.shopLink}
                                        class="ux-button ux-button--icon-only ux-iws-link-wrapper-ignore"
                                        aria-label={
                                            this.translateFn &&
                                            this.translateFn(
                                                `shopLinks.${this.shopLinkType}`
                                            )
                                        }
                                        data-testid="shop-link"
                                    >
                                        <ux-icon name="cart" />
                                    </a>
                                )}
                                {this.shopLinksLength === 2 && (
                                    <button
                                        data-ux-iws-link-wrapper-ignore
                                        class="ux-button ux-button--icon-only ux-iws-link-wrapper-ignore"
                                        onClick={() =>
                                            (this.overlayVisibility =
                                                !this.overlayVisibility)
                                        }
                                        data-testid="shop-link-multiple"
                                    >
                                        <ux-icon name="cart" />
                                    </button>
                                )}
                                {hasDetailLink && (
                                    <a
                                        href={this.detailLink}
                                        class="ux-button ux-button--icon-only ux-iws-link-wrapper-ignore"
                                        data-testid="details"
                                    >
                                        <ux-icon
                                            name="chevron-right"
                                            weight="normal"
                                        ></ux-icon>
                                    </a>
                                )}
                            </div>
                            <div
                                data-ux-iws-link-wrapper-ignore
                                class={`ux-tile-body__overlay ${
                                    this.overlayVisibility ? "is-visible" : ""
                                }`}
                            >
                                <div
                                    class="ux-tile-body__overlay-close"
                                    onClick={() =>
                                        (this.overlayVisibility =
                                            !this.overlayVisibility)
                                    }
                                    data-testid="close-overlay"
                                >
                                    <ux-icon name="close"></ux-icon>
                                </div>
                                <div class="ux-tile-body__overlay-content">
                                    <div>{this.chooseShopTitle}</div>
                                    <a
                                        href={this.shopLink}
                                        class="ux-button ux-iws-link-wrapper-ignore"
                                        aria-label={
                                            this.translateFn &&
                                            this.translateFn(
                                                `shopLinks.${this.shopLinkType}`
                                            )
                                        }
                                    >
                                        {this.shopLinkTitle}
                                        <ux-icon
                                            name={
                                                shopIcon1 || this.shopLinkIcon
                                            }
                                        />
                                    </a>
                                    <a
                                        href={this.shopLink2}
                                        class="ux-button ux-iws-link-wrapper-ignore"
                                        aria-label={
                                            this.translateFn &&
                                            this.translateFn(
                                                `shopLinks.${this.shopLink2Type}`
                                            )
                                        }
                                    >
                                        {this.shopLink2Title}
                                        <ux-icon
                                            name={
                                                shopIcon2 || this.shopLink2Icon
                                            }
                                        />
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </Wrapper>
            </Host>
        );
    }
}
